import {Validation, type ValidationConfig, type ValidationResponse, WarningLevel} from "./validations";
import type {InputType} from "../commons";
import type {FormInputElement} from "../components/formInputElement";

export type MinCheckedOptionsConfig = ValidationConfig & {
    id: "minCheckedOptions";
    count: number;
};

export class MinCheckedOptions extends Validation {

    private constructor(messageText: string, onlyWarning: WarningLevel, private count: number) {
        super(messageText, onlyWarning);
    }

    public static from(config: MinCheckedOptionsConfig): MinCheckedOptions {
        return new MinCheckedOptions(config.message, config.warningLevel, config.count);
    }

    protected valid(value: unknown): boolean {
        if (!this.isBooleanArray(value)) {
            return false;
        }
        const checkedCount = value.filter(b => b).length;
        return checkedCount >= this.count;
    }

    private isBooleanArray(value: unknown): value is boolean[] {
        return Array.isArray(value) && value.every(v => typeof v === "boolean");
    }

    public accept<T extends InputType>(inputElement: FormInputElement<T>, value?: T): void {
        const validationResponse: ValidationResponse = this.checkValidity(value);

        if (!validationResponse.valid) {
            inputElement.addMessage({warningLevel: validationResponse.warningLevel, message: this.errorText});
        }
    }
}